import fp from 'lodash/fp';
import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Spinner from 'react-spinkit';
import { bindActionCreators } from 'redux';
import { handleInvalidForm, validateEmail } from '../../../../../services';
import { currentUserSelector, userActions } from '../../../../../state/modules/user';
import { FormSubmissionMessage, InputFormField, PasswordFormField } from '../../../../components';

const form = {
  email: 'Email',
  password: 'Password'
};

class Login extends Component {
  constructor() {
    super();

    this.state = {
      email: '',
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      submissionMessage: '',
      emailValidation: true,
      passwordValidation: {
        currentPassword: true,
        newPassword: true,
        confirmPassword: true
      },
      isSubmittingEmail: false,
      isSubmittingPassword: false,
      showSubmissionMessage: false,
      focusMessage: false
    };
  }

  componentDidMount() {
    const {
      user,
    } = this.props;

    // If the currentUser is already in state, then grab the email
    if (user.id) {
      this.setState({ email: user.email });
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      user: previousUser,
      isUpdating: wasUpdating
    } = this.props;

    const {
      user: nextUser,
      isUpdating
    } = nextProps;

    // If the component mounted, but the currentUser wasn't in the state already,
    // then grab the email when it finishes fetching.
    // (Ignore any updates if we already had the currentUser in componentDidMount)
    if (!previousUser.id && nextUser.id) {
      this.setState({ email: nextUser.email });
    }

    if (wasUpdating && !isUpdating) {
      this.resetIsSubmittingForm(form.email);
      this.resetIsSubmittingForm(form.password);
    }
  }

  resetIsSubmittingForm(form) {
    this.setState({
      [`isSubmitting${form}`]: false,
      showSubmissionMessage: true,
      focusMessage: true,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    });
  }

  onFormChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onFormSubmit(event, form) {
    event.preventDefault();
    event.stopPropagation();

    const isSubmittingForm = `isSubmitting${form}`;

    if (!fp.get(isSubmittingForm)(this.state)) {
      if (fp.invoke(`validate${form}Form`)(this)) {
        this.setState({ [isSubmittingForm]: true });

        fp.invoke(`update${form}`)(this);
        this.setState({
          showSubmissionMessage: false,
          submissionMessage: `Your ${form.toLowerCase()} has successfully been updated`
        });
      } else {
        const formRef = fp.get(`formRef${form}`)(this);

        if (formRef) {
          handleInvalidForm(formRef);
        }
      }
    }
  }

  updateEmail() {
    const {
      email: newEmail
    } = this.state;

    this.props.updateUserEmail({ newEmail });
  }

  updatePassword() {
    const {
      currentPassword: oldPassword,
      newPassword
    } = this.state;

    this.props.updateUserPassword({ oldPassword, newPassword });
  }

  validateEmailForm() {
    const {
      email
    } = this.state;

    const emailValidation = validateEmail(email);

    this.setState({ emailValidation });

    return emailValidation;
  }

  validatePasswordForm() {
    const {
      currentPassword,
      newPassword,
      confirmPassword
    } = this.state;

    const passwordValidation = {
      currentPassword: currentPassword.trim() !== '',
      newPassword: newPassword.trim() !== '',
      confirmPassword: confirmPassword === newPassword
    };

    this.setState({ passwordValidation });

    return fp.all(fp.identity)(passwordValidation);
  }

  render() {
    const {
      error
    } = this.props;

    const {
      email,
      emailValidation,
      currentPassword,
      newPassword,
      confirmPassword,
      passwordValidation,
      isSubmittingEmail,
      isSubmittingPassword,
      showSubmissionMessage,
      submissionMessage
    } = this.state;

    const isSubmitting = isSubmittingEmail || isSubmittingPassword;

    return (
      <Row>
        <FormSubmissionMessage
          showSubmissionMessage={showSubmissionMessage}
          submissionMessage={submissionMessage}
          error={error}
          stopFocusingMessage={() => this.setState({ focusMessage: false })}
          hideSubmissionMessage={() => this.setState({ showSubmissionMessage: false })} />
        <Col xs={12} md={6}>
          <form
            className='email'
            ref={(form) => { this.formRefEmail = form; }}
            noValidate
            onSubmit={(e) => this.onFormSubmit(e, form.email)}>
            <fieldset>
              <p>
                <strong>Update your email</strong>
              </p>
              <InputFormField
                id='email'
                required
                validation={emailValidation ? null : 'Please provide valid email address.'}
                value={email}
                onChange={(e) => this.onFormChange(e)}>
              </InputFormField>
              <Button type='submit' className='large' disabled={isSubmitting}>
                {
                  isSubmittingEmail ?
                    <Spinner name='circle' className='spinner' fadeIn='none' /> :
                    'Update email'
                }
              </Button>
            </fieldset>
          </form>
        </Col>
        <Col xs={12} md={6}>
          <form
            className='password'
            ref={(form) => { this.formRefPassword = form; }}
            noValidate
            onSubmit={(e) => this.onFormSubmit(e, form.password)}>
            <fieldset>
              <p>
                <strong>Update your password</strong>
              </p>
              <PasswordFormField
                id='current-password'
                required
                validation={passwordValidation.currentPassword ? null : 'Current password is required.'}
                value={currentPassword}
                onChange={(e) => this.onFormChange(e)} />
              <PasswordFormField
                id='new-password'
                required
                validation={passwordValidation.newPassword ? null : 'New password is required.'}
                value={newPassword}
                onChange={(e) => this.onFormChange(e)} />
              <PasswordFormField
                id='confirm-password'
                required
                validation={passwordValidation.confirmPassword ? null : 'Must match your new password.'}
                value={confirmPassword}
                onChange={(e) => this.onFormChange(e)} />
              <Button type='submit' className='large' disabled={isSubmitting}>
                {
                  isSubmittingPassword ?
                    <Spinner name='circle' className='spinner' fadeIn='none' /> :
                    'Update password'
                }
              </Button>
            </fieldset>
          </form>
        </Col>
      </Row>
    )
  }
};

const mapStateToProps = (state) => ({
  user: currentUserSelector(state),
  isUpdating: state.user.isUpdating,
  error: state.user.error,
  token: state.session.idToken
});

const mapDispatchToProps = (dispatch) => ({
  updateUserEmail: bindActionCreators(userActions.user.updateEmail, dispatch),
  updateUserPassword: bindActionCreators(userActions.user.updatePassword, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/partials/login.js